import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { TaskProvider } from './contexts/TaskContext';
import { TimerProvider } from './contexts/TimerContext';
import { CustomThemeProvider } from './contexts/ThemeContext';
import Header from './components/Header';
import HomePage from './pages/HomePage';
import PomodoroPage from './pages/PomodoroPage';
import TodoPage from './pages/TodoPage';
import StatsPage from './pages/StatsPage';
import SettingsPage from './pages/SettingsPage';
import { Container } from '@mui/material';

function App() {
  return (
    <CustomThemeProvider>
      <TaskProvider>
        <TimerProvider>
          <Router>
            <Header />
            <Container sx={{ marginTop: 2 }}>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/pomodoro" element={<PomodoroPage />} />
                <Route path="/todo" element={<TodoPage />} />
                <Route path="/stats" element={<StatsPage />} />
                <Route path="/settings" element={<SettingsPage />} />
              </Routes>
            </Container>
          </Router>
        </TimerProvider>
      </TaskProvider>
    </CustomThemeProvider>
  );
}

export default App;